import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext'
import { Layout } from './Layout';

export const ProtectedLayout: React.FC = () => {
  console.log('[PROTECTED_LAYOUT] Component rendering');
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  console.log('[PROTECTED_LAYOUT] Auth state:', { isAuthenticated, isLoading });

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen bg-console-bg flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-console-accent border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-console-muted">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, render the protected layout
  return <Layout />;
};